import { Injectable } from '@angular/core'
import { LocalStorageService } from 'angular-2-local-storage'

@Injectable()
export class CrashService {
    constructor(
        private storage: LocalStorageService
    ) {}

    get hasCrashed(): boolean {
        return this.storage.get('crashed') || false
    }
    
    setCrashed() {
        this.storage.set('crashed', true)
    }

    clear() {
        this.storage.remove('crashed')
    }
}